// OneDrive:CoverageThreshold(92)

export * from '@ms/telemetry-manager/lib/EventBase';
